module.exports = __webpack_public_path__ + "b42798e27ab89f5c2a6880c9ca036e64.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/landing/2.png
// module id = 315
// module chunks = 1